import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import CheckBoxViewModelType from '@/ViewModels/Controls/CheckBoxViewModel';
import CheckBoxType from '@/Controls/CheckBox';

export default class CheckBoxControlColumnFactory extends ColumnFactory {

    public static isPlainText = false;
    public static isJQueryElement = true;
    private CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModelType>('CheckBoxViewModel');
    private CheckBox = ComponentManager.getControl<typeof CheckBoxType>('CheckBox');

    constructor(private params: any) {
        super(params);
    }

    public getValue(): JQuery<HTMLElement> {
        let checkBoxViewModel: CheckBoxViewModelType = this.params.checkBoxViewModel || new this.CheckBoxViewModel({
            isChecked: this.raw === "true" || this.raw === true,
            isEnabled: this.observableOrDefault(this.params.isEnabled, false)
        });

        let checkBoxControl = new this.CheckBox(checkBoxViewModel);

        let $control = checkBoxControl.getControl();

        return $control;
    }
}

ComponentManager.setFactory('CheckBoxControlColumn', CheckBoxControlColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');